import { faExternalLink, faShieldAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useRef, useState } from "react";
import { COOKIE_POLICY_URL, PRIVACY_POLICY_URL } from "../../../config";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import "./style.css";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const fm = getFormattedMessageWithScope("components.PrivacyCookiePolicyMenu");

export const PrivacyCookiePolicyMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef<any>(null);

    const onToggleMenu = useCallback(() => {
        setIsMenuOpen(!isMenuOpen);
    }, [setIsMenuOpen, isMenuOpen]);

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (
                menuRef &&
                menuRef.current &&
                !menuRef.current.contains(event.target)
            ) {
                onToggleMenu();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuRef, onToggleMenu]);

    return (
        <div className="c-PrivacyCookiePolicyMenu">
            <FontAwesomeIcon
                icon={faShieldAlt as IconProp}
                className="c-PrivacyCookiePolicyMenu-icon"
                onClick={onToggleMenu}
            />
            {isMenuOpen ? (
                <div className="c-PrivacyCookiePolicyMenu-menu" ref={menuRef}>
                    <div className="c-PrivacyCookiePolicyMenu-menu-item">
                        <a
                            href={PRIVACY_POLICY_URL}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <div className="c-PrivacyCookiePolicyMenu-menu-item-link-content">
                                {fm("privacyPolicy")}{" "}
                                <div className="c-PrivacyCookiePolicyMenu-menu-item-icon">
                                    <FontAwesomeIcon
                                        icon={faExternalLink as IconProp}
                                    />
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="c-PrivacyCookiePolicyMenu-menu-item">
                        <a
                            href={COOKIE_POLICY_URL}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <div className="c-PrivacyCookiePolicyMenu-menu-item-link-content">
                                {fm("cookiePolicy")}{" "}
                                <div className="c-PrivacyCookiePolicyMenu-menu-item-icon">
                                    <FontAwesomeIcon
                                        icon={faExternalLink as IconProp}
                                    />
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            ) : undefined}
        </div>
    );
};
